/**
 * This file includes polyfills needed by the application.
 * It is loaded before the app and main.ts.
 */

// Polyfill for Node.js global object (required by SockJS and other Node.js libraries)
(window as any).global = window;

// Polyfill for process.env if needed
(window as any).process = {
  env: { DEBUG: undefined },
};

console.log('[Polyfills] Global polyfills loaded successfully');

